module.exports = __webpack_public_path__ + "static/media/Design.368b1165.png";